// ─────────────────────────────────────────
// Floating input field
// ─────────────────────────────────────────
const InputField = ({
  label,
  value,
  onChange,
  onFocus,
  onBlur,
  focused,
  error,
  id,
}) => {
  const hasValue = value.length > 0;

  return (
    <div>
      <div
        style={{
          position: "relative",
          background: "#111",
          borderRadius: 14,
          border: `1.5px solid ${
            error
              ? "rgba(255,59,92,.5)"
              : focused
                ? "#f97316"
                : hasValue
                  ? "#2a2a2a"
                  : "#1e1e1e"
          }`,
          boxShadow: focused
            ? error
              ? "0 0 0 3px rgba(255,59,92,.12)"
              : "0 0 0 3px rgba(249,115,22,.12)"
            : "none",
          transition: "border-color .2s, box-shadow .2s",
          overflow: "hidden",
        }}
      >
        {/* Floating label */}
        <label
          htmlFor={id}
          style={{
            position: "absolute",
            left: 16,
            top: focused || hasValue ? 8 : "50%",
            transform: focused || hasValue ? "none" : "translateY(-50%)",
            fontFamily: "DM Sans, sans-serif",
            fontSize: focused || hasValue ? 10 : 14,
            fontWeight: 700,
            letterSpacing: focused || hasValue ? "0.1em" : "0.02em",
            textTransform: focused || hasValue ? "uppercase" : "none",
            color: error ? "rgba(255,59,92,.8)" : focused ? "#f97316" : "#555",
            transition: "all .2s cubic-bezier(.4,0,.2,1)",
            pointerEvents: "none",
            zIndex: 1,
          }}
        >
          {label}
        </label>

        <input
          id={id}
          type={"text"}
          value={value}
          onChange={onChange}
          onFocus={onFocus}
          onBlur={onBlur}
          className="gp-input"
          style={{
            width: "100%",
            background: "transparent",
            border: "none",
            padding: "26px 48px 10px 16px",
            fontFamily: "DM Sans, sans-serif",
            fontSize: 15,
            color: "#f5f5f5",
            letterSpacing: "0.04em",
          }}
        />
      </div>

      {/* Error message */}
      {error && (
        <div
          style={{
            marginTop: 6,
            display: "flex",
            alignItems: "center",
            gap: 5,
            fontFamily: "DM Sans, sans-serif",
            fontSize: 12,
            color: "#ff3b5c",
          }}
        >
          <span>⚠</span> {error}
        </div>
      )}
    </div>
  );
};

export default InputField;
